import {
  Button,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalProps,
} from '@ritualco/jutsu'
import { HeraModal } from 'components/HeraModal'
import { useContent } from 'lib/content/react'

export type ConnectionDeleteModalProps = {
  onConfirm?: () => void
  organizationName?: string
  workspaceName?: string
} & Omit<ModalProps, 'children'>

export const ConnectionDeleteModal = ({
  onConfirm = () => {},
  onClose,
  organizationName,
  workspaceName,
  ...modalProps
}: ConnectionDeleteModalProps) => {
  const { formatMessage } = useContent()
  return (
    <HeraModal onClose={onClose} size="sm" {...modalProps}>
      <ModalHeader>
        {formatMessage(
          { id: 'pmportal.connections.removeHeader' },
          { organizationName, workspaceName }
        )}
      </ModalHeader>
      <ModalBody>
        {formatMessage({ id: 'pmportal.connections.removeDescription' })}
      </ModalBody>
      <ModalFooter>
        <Button colorScheme="transparent" mr={2} onClick={onClose}>
          {formatMessage({ id: 'pmportal.global.actionCancel' })}
        </Button>
        <Button
          type="submit"
          onClick={async () => {
            await onConfirm()
            onClose()
          }}
          colorScheme="red"
        >
          {formatMessage({ id: 'pmportal.global.actionConfirmRemove' })}
        </Button>
      </ModalFooter>
    </HeraModal>
  )
}
